import { SubmitFormButton, useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'

export const SubmitButton = ({ enableOverride }) => {
  const { dirty, errors } = useFormContext()

  const disabled = enableOverride ? false : (!dirty || Object.keys(errors).length > 0)

  return (
    <SubmitFormButton disabled={disabled}>
      {I18n.t('publisher.action.save')}
    </SubmitFormButton>
  )
}
